module.exports = __webpack_public_path__ + "static/media/portoseguro.e651d5af.svg";